import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useRentalCarApi } from "../../http/rentalCars/api";
import ModalDialog from "../ui/ModalDialog";

type DeleteRentalCarDialogProps = {
  rentalCarId: string;
  carId?: string;
  onClose: (success?: boolean) => void;
};

const DeleteRentalCarDialog: FC<DeleteRentalCarDialogProps> = ({ rentalCarId, carId, onClose }) => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const rentalCarsApi = useRentalCarApi();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onClick = async () => {
    setIsSubmitting(true);
    try {
      await rentalCarsApi.deleteAdminRentalCar(rentalCarId, carId);
      dispatch(showSuccessNotification(i18n.t));
      onClose(true);
    } catch (error) {
      dispatch(showErrorNotification(i18n, error));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.rentalCars.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,

          onClick: onClick,
        },
      ]}
    >
      {i18n.t.rentalCars.questions.delete}
    </ModalDialog>
  );
};

export default DeleteRentalCarDialog;
